



import { useEffect ,useState} from "react";
import { usePunchReminder } from "./utils/usePunchReminder";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import Login from "./modules/auth/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleRoute from "./components/RoleRoute";
import { Toaster } from "react-hot-toast";
import CallManager from "./components/CallManager";
import CreateProject from "./pages/projects/CreateProject";
import CreateAppPage from "./pages/projects/CreateAppPage";
import AppsListPage from "./pages/projects/AppsListPage";
import Gallery from "./pages/gallery/Gallery";
import PublicScreenshots from "./pages/gallery/PublicScreenshots";
import AppsMy from "./pages/projects/AppsMy";
import GrievancePage from "./pages/grievance/GrievancePage";


import ProjectsListPage from "./pages/projects/ProjectsListPage";
import ProjectsMy from "./pages/projects/ProjectsMy";
import ProjectVideoPage from "./pages/projects/ProjectVideoPage";
// ProjectVideoPage

// import Cookies from "js-cookie";

/* Employees */
import Employees from "./pages/employees/Employees";
import CreateUser from "./pages/employees/CreateUser";
import Departments from "./pages/employees/Departments";
import ExEmployees from "./pages/employees/ExEmployees";

/* Attendance */
import MyAttendance from "./pages/attendance/MyAttendance";
import AllAttendance from "./pages/attendance/AllAttendance";
import MonthlyAttendance from "./pages/attendance/MonthlyAttendance";
import UserMonthlyData from "./pages/attendance/UserMonthlyData";
// import UserTasks from "./pages/attendance/UserTasks";
/* Expenses */
import AddExpense from "./pages/expenses/AddExpense";
import ExpenseList from "./pages/expenses/ExpenseList";
import Wallet from "./pages/expenses/Wallet";
import Categories from "./pages/expenses/Categories";

/* Leaves */
import ApplyLeave from "./pages/leaves/ApplyLeave";
import MyLeaves from "./pages/leaves/MyLeaves";
import PendingLeaves from "./pages/leaves/PendingLeaves";
import LeaveReport from "./pages/leaves/LeaveReport";
import LeavePolicy from "./pages/leaves/LeavePolicy";
import Holidays from "./pages/leaves/Holidays";

/* Inventory */
import Inventory from "./pages/inventory/Inventory";
import AssignItems from "./pages/inventory/AssignItems";
import AddItem from "./pages/inventory/AddItem";

import Profile from "./pages/profile/Profile";
import UserProfile from "./pages/profile/UserProfile";
import TasksPage from "./pages/tasks/TasksPage";
import AssignedTasks from "./pages/tasks/AssignedTasks";
import Payroll from "./pages/payroll/Payroll";
import EmployeeSalaries from "./pages/payroll/EmployeeSalaries";
import PayrollRecords from "./pages/payroll/PayrollRecords";
import Payslips from "./pages/payroll/Payslips";
import Increment from "./pages/payroll/Increment";

import WorkingStatusModal from "../src/components/WorkingStatusModal";
 


import { connectSocket, getSocket } from './socket/socket';
import TaskDetails from "./pages/dashboard/components/TaskDetails";
import TaskDetailsMy from "./pages/dashboard/components/TaskDetailsMy";
import TeamTasks from "./pages/dashboard/components/TeamTasks";

import TeamsPage from "./pages/dashboard/components/teams/TeamsPage";
import TeamDetailsPage from "./pages/dashboard/components/teams/TeamDetailsPage";
import UserTaskBoard from "./pages/dashboard/components/UserTaskBoard";

import CreateFeed from "./pages/posts/CreateFeed";
import AllDocuments from "./pages/documents/AllDocuments";
import UploadDocuments from "./pages/documents/UploadDocuments";
import MiniHeader from "././components/MiniHeader";

export default function App() {


  // eslint-disable-next-line no-unused-vars
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "dark"
  );

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  const [socketReady, setSocketReady] = useState(false);

  useEffect(() => {
    connectSocket();
    // Add small delay to ensure socket instance is available to components
    setTimeout(() => {
      setSocketReady(true);
    }, 500);
  }, []);

  useEffect(() => {
    if (!socketReady) return;

    const socket = getSocket();
    if (socket) {
      socket.on("attendance_updated", (data) => {
        console.log("⚡ [Socket] attendance_updated received. Dispatching window event...", data);
        window.dispatchEvent(new CustomEvent("attendance-updated", { detail: data }));
      });

      socket.on("leave_updated", (data) => {
        console.log("⚡ [Socket] leave_updated received. Dispatching window event...", data);
        window.dispatchEvent(new CustomEvent("leave-updated", { detail: data }));
      });
    }

    return () => {
      if (socket) {
        socket.off("attendance_updated");
        socket.off("leave_updated");
      }
    };
  }, [socketReady]);










// ====notifi==================
useEffect(() => {
  if ("Notification" in window && Notification.permission !== "granted") {
    Notification.requestPermission().then((permission) => {
      console.log("🔔 Notification permission:", permission);
    });
  }
}, []);

// ====punch-in background reminder SW====
usePunchReminder();









 
  return (
    <>
      <Toaster position="top-right" containerStyle={{ zIndex: 999999 }} />
      {socketReady && <CallManager />}
      <WorkingStatusModal />
      <BrowserRouter>
        <Routes>

          {/* LOGIN */}
          <Route path="/login" element={<Login />} />
          {/* <Route
          path="/login"
          element={token ? <Navigate to="/" replace /> : <Login />}
        /> */}
      <Route path="/mini" element={<MiniHeader />} />
          {/* PROTECTED AREA */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<DashboardLayout />}>
            <Route path="/user/:id" element={<TaskDetails />} />
            <Route path="/task-details-my" element={<TaskDetailsMy />} />
            <Route path="/team-task" element={<TeamTasks />} />
            <Route path="/tasks/assigned" element={<AssignedTasks />} />
            <Route path="/dashboard/teams" element={<TeamsPage />} />
<Route path="/dashboard/teams/:id" element={<TeamDetailsPage />} />
              <Route index element={<Dashboard />} />

              {/* PROFILE + TASKS (ALL USERS) */}
              <Route path="profile" element={<Profile />} />
              <Route path="/users/:id" element={<UserProfile />} />
              <Route path="/payroll" element={<RoleRoute allowedRoles={[2]}><Payroll /></RoleRoute>} />
              <Route path="/payroll/records" element={<RoleRoute allowedRoles={[2]}><PayrollRecords /></RoleRoute>} />
              <Route path="/payroll/salaries" element={<RoleRoute allowedRoles={[2]}><EmployeeSalaries /></RoleRoute>} />
              <Route path="/tasks/:view" element={<TasksPage />} />





              <Route
  path="/dashboard/user-monthly-tasks/:id"
  element={<UserTaskBoard />}
/>

{/* =====================================usertask======================================== */}
              {/* <Route path="/tasks/me" element={<TasksPage />} />
<Route path="/tasks/me/:view" element={<TasksPage />} /> */}
             
              {/* ================= EMPLOYEES (HR ONLY) ================= */}
              <Route
                path="employees"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <Employees />
                  </RoleRoute>
                }
              />
              <Route
                path="employees/create"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <CreateUser />
                  </RoleRoute>
                }
              />
              <Route
                path="departments"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <Departments />
                  </RoleRoute>
                }
              />
              <Route
                path="employees/ex"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <ExEmployees />
                  </RoleRoute>
                }
              />

              {/* ================= ATTENDANCE ================= */}
              <Route path="attendance/me" element={<MyAttendance />} />

              <Route
                path="attendance/all"
                element={
                  <RoleRoute allowedRoles={[1, 2]}>
                    <AllAttendance />
                  </RoleRoute>
                }
              />
              <Route
                path="attendance/monthly"
                element={
                  <RoleRoute allowedRoles={[1, 2]}>
                    <MonthlyAttendance />
                  </RoleRoute>
                }
              />

<Route
                path="/attendance/monthly/user"
                element={
                  <RoleRoute allowedRoles={[1, 2]}>
                    <UserMonthlyData />
                  </RoleRoute>
                }
              />



              {/* ================= EXPENSES (HR + ADMIN) ================= */}
              <Route
                path="expenses/add"
                element={
                  <RoleRoute allowedRoles={[1, 2]}>
                    <AddExpense />
                  </RoleRoute>
                }
              />
              <Route
                path="expenses"
                element={
                  <RoleRoute allowedRoles={[1, 2]}>
                    <ExpenseList />
                  </RoleRoute>
                }
              />
              <Route
                path="expenses/wallet"
                element={
                  <RoleRoute allowedRoles={[1, 2]}>
                    <Wallet />
                  </RoleRoute>
                }
              />
              <Route
                path="expenses/categories"
                element={
                  <RoleRoute allowedRoles={[1, 2]}>
                    <Categories />
                  </RoleRoute>
                }
              />

              {/* ================= LEAVES ================= */}
              <Route path="leaves/apply" element={<ApplyLeave />} />
              <Route path="leaves/me" element={<MyLeaves />} />
              <Route path="leaves/policy" element={<LeavePolicy />} />
              <Route path="leaves/holidays" element={<Holidays />} />

              <Route
                path="leaves/pending"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <PendingLeaves />
                  </RoleRoute>
                }
              />
              <Route
                path="leaves/report"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <LeaveReport />
                  </RoleRoute>
                }
              />


{/* ======================postrs===================== */}
<Route path="/posts/create" element={<CreateFeed />} />


{/* ======grievance */}
<Route path="grievance" element={<GrievancePage />} />
              
              {/* ================= PAYROLL (HR ONLY) ================= */}
              <Route
                path="payroll"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <Payroll />
                  </RoleRoute>
                }
              />
              <Route
                path="payroll/salaries"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <EmployeeSalaries />
                  </RoleRoute>
                }
              />
              <Route
                path="payroll/payslips"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <Payslips />
                  </RoleRoute>
                }
              />
              <Route
                path="payroll/increment"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <Increment />
                  </RoleRoute>
                }
              />
 



        {/* ===========================documents============ */}
        <Route path="/upload/documents" element={<UploadDocuments />} />
<Route path="/documents/all" element={<AllDocuments />} />
<Route path="/gallery" element={<Gallery />} />
<Route path="/screenshots" element={<PublicScreenshots />} />


{/* ==================================projects=========================================== */}
<Route path="/projects/create" element={<CreateProject />} />

<Route path="/apps/create" element={<CreateAppPage />} />
<Route path="/projects/all" element={<ProjectsListPage />} />

{/* <Route path="/projects/video/:id" element={<ProjectVideoPage />} /> */}
<Route path="/projects/video/:id" element={<ProjectVideoPage />} />

<Route path="/apps/list" element={<AppsListPage />} />
<Route path="/projects/my" element={<ProjectsMy />} />
<Route path="/apps/my" element={<AppsMy />} />






              {/* ================= INVENTORY (ADMIN ONLY) ================= */}
              <Route
                // path="inventory"
                path="/inventory/all"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <AddItem />
                  </RoleRoute>
                }
                // element={<AddItems/>}
              />
              <Route
                path="inventory/add"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <Inventory />
                  </RoleRoute>
                }
              />
              <Route
                path="inventory/assign"
                element={
                  <RoleRoute allowedRoles={[2]}>
                    <AssignItems />
                  </RoleRoute>
                }
              />
              
            </Route>
          </Route>

          {/* FALLBACK */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}










// import { useEffect } from "react";

// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import DashboardLayout from "./layouts/DashboardLayout";
// import Dashboard from "./pages/dashboard/Dashboard";
// import Login from "./modules/auth/Login";
// import ProtectedRoute from "./components/ProtectedRoute";
// import RoleRoute from "./components/RoleRoute";
// import { Toaster } from "react-hot-toast";


// // import Cookies from "js-cookie";

// /* Employees */
// import Employees from "./pages/employees/Employees";
// import CreateUser from "./pages/employees/CreateUser";
// import Departments from "./pages/employees/Departments";
// import ExEmployees from "./pages/employees/ExEmployees";

// /* Attendance */
// import MyAttendance from "./pages/attendance/MyAttendance";
// import AllAttendance from "./pages/attendance/AllAttendance";
// import MonthlyAttendance from "./pages/attendance/MonthlyAttendance";
// // import UserTasks from "./pages/attendance/UserTasks";
// /* Expenses */
// import AddExpense from "./pages/expenses/AddExpense";
// import ExpenseList from "./pages/expenses/ExpenseList";
// import Wallet from "./pages/expenses/Wallet";
// import Categories from "./pages/expenses/Categories";

// /* Leaves */
// import ApplyLeave from "./pages/leaves/ApplyLeave";
// import MyLeaves from "./pages/leaves/MyLeaves";
// import PendingLeaves from "./pages/leaves/PendingLeaves";
// import LeaveReport from "./pages/leaves/LeaveReport";
// import LeavePolicy from "./pages/leaves/LeavePolicy";
// import Holidays from "./pages/leaves/Holidays";

// /* Inventory */
// import Inventory from "./pages/inventory/Inventory";
// import AssignItems from "./pages/inventory/AssignItems";
// import AddItem from "./pages/inventory/AddItem";

// import Profile from "./pages/profile/Profile";
// import UserProfile from "./pages/profile/UserProfile";
// import TasksPage from "./pages/tasks/TasksPage";
// import {connectSocket} from './socket/socket'
// import TaskDetails from "./pages/dashboard/components/TaskDetails";
// import TaskDetailsMy from "./pages/dashboard/components/TaskDetailsMy";
// import TeamTasks from "./pages/dashboard/components/TeamTasks";

// import TeamsPage from "./pages/dashboard/components/teams/TeamsPage";
// import TeamDetailsPage from "./pages/dashboard/components/teams/TeamDetailsPage";

// import CreateFeed from "./pages/posts/CreateFeed";
// import AllDocuments from "./pages/documents/AllDocuments";
// import UploadDocuments from "./pages/documents/UploadDocuments";
// import MiniHeader from "././components/MiniHeader";

// export default function App() {

//   useEffect(() => {
//     connectSocket();
//   }, []);
 
//   return (
//     <>
//       <Toaster position="top-right" />
//       <BrowserRouter>
//         <Routes>

//           {/* LOGIN */}
//           <Route path="/login" element={<Login />} />
//           {/* <Route
//           path="/login"
//           element={token ? <Navigate to="/" replace /> : <Login />}
//         /> */}
//       <Route path="/mini" element={<MiniHeader />} />
//           {/* PROTECTED AREA */}
//           <Route element={<ProtectedRoute />}>
//             <Route path="/" element={<DashboardLayout />}>
//             <Route path="/user/:id" element={<TaskDetails />} />
//             <Route path="/task-details-my" element={<TaskDetailsMy />} />
//             <Route path="/team-task" element={<TeamTasks />} />
//             <Route path="/dashboard/teams" element={<TeamsPage />} />
// <Route path="/dashboard/teams/:id" element={<TeamDetailsPage />} />
//               <Route index element={<Dashboard />} />

//               {/* PROFILE + TASKS (ALL USERS) */}
//               <Route path="profile" element={<Profile />} />
//               <Route path="/users/:id" element={<UserProfile />} />
//               <Route path="/tasks/:view" element={<TasksPage />} />

// {/* =====================================usertask======================================== */}
//               {/* <Route path="/tasks/me" element={<TasksPage />} />
// <Route path="/tasks/me/:view" element={<TasksPage />} /> */}
             
//               {/* ================= EMPLOYEES (HR ONLY) ================= */}
//               <Route
//                 path="employees"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <Employees />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="employees/create"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <CreateUser />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="departments"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <Departments />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="employees/ex"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <ExEmployees />
//                   </RoleRoute>
//                 }
//               />

//               {/* ================= ATTENDANCE ================= */}
//               <Route path="attendance/me" element={<MyAttendance />} />

//               <Route
//                 path="attendance/all"
//                 element={
//                   <RoleRoute allowedRoles={[1, 2]}>
//                     <AllAttendance />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="attendance/monthly"
//                 element={
//                   <RoleRoute allowedRoles={[1, 2]}>
//                     <MonthlyAttendance />
//                   </RoleRoute>
//                 }
//               />

//               {/* ================= EXPENSES (HR + ADMIN) ================= */}
//               <Route
//                 path="expenses/add"
//                 element={
//                   <RoleRoute allowedRoles={[1, 2]}>
//                     <AddExpense />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="expenses"
//                 element={
//                   <RoleRoute allowedRoles={[1, 2]}>
//                     <ExpenseList />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="expenses/wallet"
//                 element={
//                   <RoleRoute allowedRoles={[1, 2]}>
//                     <Wallet />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="expenses/categories"
//                 element={
//                   <RoleRoute allowedRoles={[1, 2]}>
//                     <Categories />
//                   </RoleRoute>
//                 }
//               />

//               {/* ================= LEAVES ================= */}
//               <Route path="leaves/apply" element={<ApplyLeave />} />
//               <Route path="leaves/me" element={<MyLeaves />} />
//               <Route path="leaves/policy" element={<LeavePolicy />} />
//               <Route path="leaves/holidays" element={<Holidays />} />

//               <Route
//                 path="leaves/pending"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <PendingLeaves />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="leaves/report"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <LeaveReport />
//                   </RoleRoute>
//                 }
//               />


// {/* ======================postrs===================== */}
// <Route path="/posts/create" element={<CreateFeed />} />





//         {/* ===========================documents============ */}
//         <Route path="/upload/documents" element={<UploadDocuments />} />
// <Route path="/documents/all" element={<AllDocuments />} />


//               {/* ================= INVENTORY (ADMIN ONLY) ================= */}
//               <Route
//                 // path="inventory"
//                 path="/inventory/all"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <AddItem />
//                   </RoleRoute>
//                 }

//                 path="/inventory/all"
//                 // element={<AddItems/>}
//               />
//               <Route
//                 path="inventory/add"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <Inventory />
//                   </RoleRoute>
//                 }
//               />
//               <Route
//                 path="inventory/assign"
//                 element={
//                   <RoleRoute allowedRoles={[2]}>
//                     <AssignItems />
//                   </RoleRoute>
//                 }
//               />





      
//             </Route>
//           </Route>

//           {/* FALLBACK */}
//           <Route path="*" element={<Navigate to="/login" />} />
//         </Routes>
//       </BrowserRouter>
//     </>
//   );
// }





